import { render, staticRenderFns } from "./ResourcesListView.vue?vue&type=template&id=580b01da&scoped=true"
import script from "./ResourcesListView.vue?vue&type=script&lang=js"
export * from "./ResourcesListView.vue?vue&type=script&lang=js"
import style0 from "./ResourcesListView.vue?vue&type=style&index=0&id=580b01da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b01da",
  null
  
)

export default component.exports